import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { useFormContext } from "../../context/FormContext";
import { decodeSearchParams } from "../../utils/urlParams";
import IncompleteBookingBanner from "../../components/IncompleteBookingBanner";
import HeroSection from "./sections/HeroSection";
import TrustBar from "./sections/TrustBar";
import Destinations from "./sections/Destinations";
import WhyChooseUs from "./sections/WhyChooseUs";
import TrustedBy from "./sections/TrustedBy";
import FAQ from "./sections/FAQ";
import Newsletter from "./sections/Newsletter";

function Home() {
  const [searchParams] = useSearchParams();
  const {
    setPickup,
    setPickupLocationObj,
    setPickupGDSCode,
    setDropoff,
    setDropoffLocationObj,
    setDropOffGDSCode,
    setPickupDate,
    setPickupTime,
    setDropoffDate,
    setDropoffTime,
    setSameLocation,
    setPromoCode,
  } = useFormContext();

  // Clear stale context from a previous session when the user lands on home
  // directly (new tab, typed URL, bookmark) rather than navigating back from
  // /results. sessionStorage is cleared when the browser tab closes, so its
  // absence reliably means this is a fresh session with no active search.
  useEffect(() => {
    const visitedResults = sessionStorage.getItem("srch_results_visited") === "1";
    if (!visitedResults) {
      setPickup("");
      setPickupLocationObj(null);
      setPickupGDSCode("");
      setDropoff("");
      setDropoffLocationObj(null);
      setDropOffGDSCode("");
      setPickupDate("");
      setDropoffDate("");
    }
  }, [
    setPickup,
    setPickupLocationObj,
    setPickupGDSCode,
    setDropoff,
    setDropoffLocationObj,
    setDropOffGDSCode,
    setPickupDate,
    setDropoffDate,
  ]);

  // Load URL parameters into form context when component mounts
  useEffect(() => {
    const urlParams = decodeSearchParams(searchParams.toString());

    // Only update form context if we have URL parameters
    if (searchParams.toString()) {
      if (urlParams.pickupLocation) {
        setPickup(urlParams.pickupLocation);
      }
      if (urlParams.pickupGDSCode) {
        setPickupGDSCode(urlParams.pickupGDSCode);
      }
      if (urlParams.dropoffLocation) {
        setDropoff(urlParams.dropoffLocation);
      }
      if (urlParams.dropoffGDSCode) {
        setDropOffGDSCode(urlParams.dropoffGDSCode);
      }
      if (urlParams.pickupDate) {
        setPickupDate(urlParams.pickupDate);
      }
      if (urlParams.pickupTime) {
        setPickupTime(urlParams.pickupTime);
      }
      if (urlParams.dropoffDate) {
        setDropoffDate(urlParams.dropoffDate);
      }
      if (urlParams.dropoffTime) {
        setDropoffTime(urlParams.dropoffTime);
      }
      if (urlParams.sameLocation !== undefined) {
        setSameLocation(urlParams.sameLocation);
      }
      if (urlParams.promoCode) {
        setPromoCode(urlParams.promoCode);
      }
    }
  }, [
    searchParams,
    setPickup,
    setPickupGDSCode,
    setDropoff,
    setDropOffGDSCode,
    setPickupDate,
    setPickupTime,
    setDropoffDate,
    setDropoffTime,
    setSameLocation,
    setPromoCode,
  ]);

 return (
  <div>
    <IncompleteBookingBanner />
    <HeroSection />

    <div className="flex flex-col">
      <div className="hidden md:block md:order-1">
        <TrustBar />
      </div>
      <div className="order-2 md:order-2">
        <Destinations />
      </div>
      <div className="block md:hidden order-1">
        <WhyChooseUs />
      </div>
      <div className="hidden md:block md:order-3">
        <WhyChooseUs />
      </div>
    </div>

    <TrustedBy />
    <FAQ />
    <Newsletter />
  </div>
);
}

export default Home;
